module.exports = __webpack_public_path__ + "static/node-0cb17d27a580a7beae03169f3fd1bc93.png";